<template>
    <div>
        <enter-kid-mode-modal></enter-kid-mode-modal>
        <exit-kid-mode-modal></exit-kid-mode-modal>
    </div>
</template>

<script>

import EnterKidModeModal from './EnterKidModeModal';
import ExitKidModeModal from './ExitKidModeModal';

export default {

    components: {
        EnterKidModeModal,
        ExitKidModeModal,
    },

};

</script>



// WEBPACK FOOTER //
// resources/js/components/modals/Modals.vue